import React, { useState } from "react";
import { getApi } from "../../api/endpoints.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import FiltersPartial from "./FiltersPartial.js";
import { selectQueryParams } from "../../ui/customerListingReducer.js";
import { useSelector } from "react-redux";
import QrCode from '../../components/QrCode.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQrcode } from "@fortawesome/free-solid-svg-icons";

const Index = () => {
  const defaultHeaderConfig = { disableSort: false };
  const [filtersModel, setFiltersModel] = useState(useSelector(selectQueryParams)["filters"]);
  const [openedVehicleQr, setOpenedVehicleQr] = useState(undefined)

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Registration Number',
      value: (row) => {
        return <div>
          {row.registration_number} {row.bike_name ? `[${row.bike_name}]`: ""} &ensp; &ensp;
          {row.registration_number && <FontAwesomeIcon onClick={(e) => setOpenedVehicleQr(row)} icon={faQrcode} />}
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Owner id - Owner Name',
      value: (row) => {
        return <div>
          {row.owner_id} - {row.owner_name}
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Vehicle Details',
      value: (row) => {
        return <div>
          <strong>Battery Model </strong>: {row.vehicle_type?.battery_model_id} &ensp; &ensp;
          <strong>Batteries </strong>: {row.vehicle_type?.no_of_batteries}
          <br/>
          <strong>Type </strong>: {row.vehicle_type?.type} &ensp; &ensp; &ensp;
          <strong>Vehicle Category </strong>: {row.vehicle_type?.vehicle_category}
        </div>
      },
      disableSort: true
    },
  ]

  return <>
  <QrCode heading={`QR code for Vehicle ${openedVehicleQr?.registration_number}`} data={openedVehicleQr?.registration_number} onHideQrCode={setOpenedVehicleQr}/> 
  <ListingPageComponent
    key={PAGES.VehiclesListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.VehiclesListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Vehicles'}]}
    listingMutation={getApi('vehicles')}
    className="vehicles-listing-page"
    contentHeading="Vehicles List - Results"
    headers={headers}
    recordsKey="vehicles"
    filtersModel={filtersModel}
    filters={
      <FiltersPartial
        filtersModel={filtersModel}
        setFiltersModel={setFiltersModel}
      />
    }
    searchBy={['ID', 'Registration Number (Number Only)']}
  /></>
};

export default Index;
